import { getLocaleLanguage } from '@systemeio/ui'
import { AutomationRulesActionsType } from 'modules/automation-rules/actions/types/automation-rule-action-interface'
import { AccessTypeCaptions } from 'modules/courses/courses/curriculum/enums/access-type-enum'
import { isPartialType } from 'modules/courses/courses/curriculum/utils/is-partial-type'
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import { AutomationRuleActionsEnum } from '../enums/action-enum'

export const ActionListContent = ({ action }: { action: AutomationRulesActionsType }) => {
  const { t } = useLocoTranslation()

  switch (action.type) {
    case AutomationRuleActionsEnum.add_tag:
    case AutomationRuleActionsEnum.remove_tag: {
      return <>{action.tag.name}</>
    }
    case AutomationRuleActionsEnum.subscribe_to_campaign:
    case AutomationRuleActionsEnum.unsubscribe_from_campaign: {
      return <>{action.campaign.name}</>
    }
    case AutomationRuleActionsEnum.create_user:
    case AutomationRuleActionsEnum.create_white_label_user: {
      return (
        <>{`${t('dashboard.automation_rule.action.new_user_language')}: ${getLocaleLanguage(
          action.locale,
        )}`}</>
      )
    }
    case AutomationRuleActionsEnum.send_email_to_specific_address: {
      return <>{action.emailMessageWithRecipient.mailing.currentEmail.subject}</>
    }
    case AutomationRuleActionsEnum.send_email: {
      return <>{action.systemeEmail.subject}</>
    }
    case AutomationRuleActionsEnum.enroll_in_course: {
      return (
        <span>
          {`${action.course.name}: ${t(AccessTypeCaptions[action.accessType])}`}
          {isPartialType(action.accessType) && action.courseModules?.length
            ? ` (${action.courseModules.map(({ name }) => name).join(', ')})`
            : ''}
        </span>
      )
    }
    case AutomationRuleActionsEnum.revoke_access_to_course: {
      return <>{action.course.name}</>
    }
    case AutomationRuleActionsEnum.send_webhook: {
      return <span>{`${t('dashboard.automation_rule.webhook_url')}: ${action.webhookUrl}`}</span>
    }
    case AutomationRuleActionsEnum.grant_access_to_community:
    case AutomationRuleActionsEnum.revoke_access_to_community: {
      // TODO remove ? after backend fix
      return <>{action.community?.name ?? ''}</>
    }
    case AutomationRuleActionsEnum.enroll_in_course_bundle: {
      return (
        <span>
          <LinkWithoutPrefetch
            className="hover:text-brand-primary w-full truncate"
            href={`/courses/bundles/${action.courseBundle.id}`}
          >
            {action.courseBundle.name}
          </LinkWithoutPrefetch>
          : {t(AccessTypeCaptions[action.enrollmentAccessType])}
        </span>
      )
    }
    case AutomationRuleActionsEnum.revoke_access_to_course_bundle: {
      return <>{action.courseBundle?.name ?? ''}</>
    }
    case AutomationRuleActionsEnum.assign_to_pipeline_stage: {
      return <>{action.pipelineStage.name}</>
    }
    case AutomationRuleActionsEnum.send_sms: {
      return <>{action.smsTemplate.name}</>
    }
  }
}
